import React, { useMemo, useState, useEffect, useRef } from 'react';
import Card from "../../../Components/Card/Card"
import BitacoraEventosConcesionTable from "../Components/BitacoraEventosConcesionTable";
import BitacoraHallazgoTable from "../Components/BitacoraHallazgoTable";
import { COLUMNS as COLUMNS_EVENTOS } from '../Utils/ColumnsEventosConcesion';
import { COLUMNS as COLUMNS_HALLAZGO } from '../Utils/ColumnsBitacoraHallazgo';
import { EnumModuloDesc, EnumPathRutas, EnumTablaPaginacion } from '../../../Utils/Enumeradores/ComunEnum'
import { BusquedaEventosConcesion } from '../Services/BusquedaEventosConcesion';
import { BusquedaBitacoraHallazgoService } from '../Services/BusquedaBitacoraHallazgoService';
import { useComun } from '../../../Hooks/useComun';
import ModalDetalleEventoConcesion from '../../../Components/ModalDetalleEventoConcesion/ModalDetalleEventoConcesion';
import { Link, useLocation } from 'react-router-dom';
import useLogin from '../../Autenticacion/Hooks/useLogin';
import { useRegistroTDR } from '../../../Hooks/useRegistroTDR';
import Tabs from 'react-bootstrap/Tabs';
import Tab from 'react-bootstrap/Tab';
import ModalDetalleHallazgoBitacora from '../Components/ModalDetalleHallazgoBitacora';

const BitacoraEventosConcesionPage = () => {
	const { downloadCSV, listadoEstado, obtieneEstadoHallazgo, obtenerListaTipoHallazgo, listadoTipoHallazgo } = useComun();
	const columns = useMemo(() => COLUMNS_EVENTOS, []);
	const columnsHallazgo = useMemo(() => COLUMNS_HALLAZGO, []);
	const [data, setData] = useState([]);
	const [dataHallazgo, setDataHallazgo] = useState([]);
	const handleClose = () => setShow(false);
	const handleCloseHallazgo = () => setShowHallazgo(false);
	const [datosModal, setDatosModal] = useState({});
	const [datosModalHallazgo, setDatosModalHallazgo] = useState({});
	const [show, setShow] = useState(false);
	const [showHallazgo, setShowHallazgo] = useState(false);
	const [pageCount, setPageCount] = useState(0);
	const [pageCountHallazgo, setPageCountHallazgo] = useState(0);
	const [key, setKey] = useState("eventos");
	const { usuario } = useLogin();
	const { crearRegistroTDR } = useRegistroTDR();
	const location = useLocation();
	let datos = location.state || null;
	const [datosInformeConservacion, setDatosInformeConservacion] = useState(datos);
	const datosRef = useRef(datos);
	const [{ pageIndex, pageSize, sortBy }, setPagination] =
		useState({
			pageIndex: 0,
			pageSize: EnumTablaPaginacion.CantidadPaginacion,
			sortBy: []
		});
	const [{ pageIndex: pageIndexHallazgo, pageSize: pageSizeHallazgo, sortBy: sortByHallazgo }, setPaginationHallazgo] =
		useState({
			pageIndex: 0,
			pageSize: EnumTablaPaginacion.CantidadPaginacion,
			sortBy: []
		});


	useEffect(() => {
		datosRef.current = datosInformeConservacion;
	}, [datosInformeConservacion]);

	useEffect(() => {
		if (key === "hallazgo") {
			obtieneEstadoHallazgo();
			obtenerListaTipoHallazgo();
		}
	}, [key]);

	async function postBusquedaEventosConcesion(values) {
		values.datosBusqueda.informeConservacionId = datosRef.current
			? datosRef.current.informeConservacionId
			: null;

		const startTime = new Date();
		const resp = await BusquedaEventosConcesion(values);
		if (resp) {
			if (resp.status === 200) {
				if (resp.data) {
					if (values.datosBusqueda.exportacion) {
						const fetchData = async () => {
							await Promise.all([
								downloadCSV(resp.data, "Bitácora Eventos Concesión", EnumModuloDesc.DescargaBitacoraEvento),
							]);
							const endTime = new Date();
							const tdrId = 21;
							crearRegistroTDR(startTime, endTime, usuario, tdrId);
						};

						fetchData();
					} else {
						setPageCount(resp.data.cantidadPaginas);
						setData(resp.data.listadoBitacoraEventoConcesion);
					}
				}
			} else if (resp.status === 206) {
				if (!values.datosBusqueda.exportacion) {
					setPageCount(0);
					setData([]);
				}
			}
		}
	}

	const fetchData = React.useCallback(({ formulario, pageIndex, sortBy = [], exportacion = false }) => {
		const startTime = new Date();
		formulario.paginacion.numeroPagina = pageIndex + 1;
		formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
		formulario.paginacion.orderByAscending = sortBy.length > 0 ? (sortBy[0].desc ? false : true) : formulario.paginacion.orderByAscending;
		formulario.datosBusqueda.exportacion = exportacion;
		const fetchData = async () => {
			await Promise.all([
				postBusquedaEventosConcesion(formulario)
			]);
			const endTime = new Date();
			const tdrId = 19;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};

		fetchData();
	}, []);

	async function postBuscadorHallazgos(values) {
		const startTime = new Date();
		const resp = await BusquedaBitacoraHallazgoService(values);
		if (resp) {
			if (resp.status === 200) {
				if (resp.data) {
					if (values.datosBusqueda.exportacion) {
						const fetchData = async () => {
							await Promise.all([
								downloadCSV(resp.data, "Hallazgos", EnumModuloDesc.DescargaGestionHallazgos)
							]);
							const endTime = new Date();
							const tdrId = 39;
							crearRegistroTDR(startTime, endTime, usuario, tdrId);
						};

						fetchData();
					} else {
						setPageCountHallazgo(resp.data.cantidadPaginas);
						setDataHallazgo(resp.data.listadoBitacoraHallazgo || resp.data.listadoBitacoraEventoConcesion || resp.data.listadoHallazgos || []);
					}
				}
			} else if (resp.status === 206) {
				if (!values.datosBusqueda.exportacion) {
					setPageCountHallazgo(0);
					setDataHallazgo([]);
				}
			}
		}
	}

	const fetchDataHallazgo = React.useCallback(({ formulario, pageIndex, sortBy = [], exportacion = false }) => {
		formulario.paginacion.numeroPagina = pageIndex + 1;
		formulario.paginacion.ordenadoPor = sortBy.length > 0 ? sortBy[0].id : formulario.paginacion.ordenadoPor;
		formulario.paginacion.orderByAscending = sortBy.length > 0 ? (sortBy[0].desc ? false : true) : formulario.paginacion.orderByAscending;
		formulario.datosBusqueda.exportacion = exportacion;
		postBuscadorHallazgos(formulario);
	}, []);

	function handlerModal(item) {
		const startTime = new Date();
		const fetchData = async () => {
			await Promise.all([
				setDatosModal(item),
				setShow(true),
			]);
			const endTime = new Date();
			const tdrId = 22;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};

		fetchData();
	}

	function handlerModalHallazgo(item) {
		const startTime = new Date();
		const fetchData = async () => {
			await Promise.all([
				setDatosModalHallazgo(item),
				setShowHallazgo(true),
			]);
			const endTime = new Date();
			const tdrId = 42;
			crearRegistroTDR(startTime, endTime, usuario, tdrId);
		};
		fetchData();
	}
	
	return (
		<div className="container-fluid">
			<div className="row mb-4">
				<div className="col-12">
					<div className="breadcrumbs">
						<ul>
							<li><Link to={EnumPathRutas.Inicio}> Inicio</Link></li>
							<li><a href="" onClick={(e) => { e.preventDefault(); window.location.reload(false); }}>Bitácora</a></li>
							<li><a href="">Eventos Concesión</a></li>
						</ul>
					</div>
				</div>
			</div>
			<div className="row">
				<div className="col-12">
					<Card className="p-4">
						<Tabs
							defaultActiveKey="eventos"
							activeKey={key}
							transition={false}
							id="bitacora-eventos-concesion"
							className="bitacora-eventos-tabs"
							onSelect={(k) => setKey(k || "eventos")}
						>
							<Tab eventKey="eventos" title="Eventos">
								{key === "eventos" &&
									<BitacoraEventosConcesionTable
										columns={columns}
										data={data}
										fetchData={fetchData}
										pageCount={pageCount}
										currentpage={pageIndex}
										pageSize={pageSize}
										sortBy={sortBy}
										setPagination={setPagination}
										handlerModal={handlerModal}
										datosInformeConservacion={datosInformeConservacion}
										setDatosInformeConservacion={setDatosInformeConservacion}
									/>
								}
							</Tab>
							<Tab eventKey="hallazgo" title="Hallazgo">
								{key === "hallazgo" &&
									<BitacoraHallazgoTable
										columns={columnsHallazgo}
										data={dataHallazgo}
										fetchData={fetchDataHallazgo}
										pageCount={pageCountHallazgo}
										currentpage={pageIndexHallazgo}
										pageSize={pageSizeHallazgo}
										sortBy={sortByHallazgo}
										setPagination={setPaginationHallazgo}
										handlerModal={handlerModalHallazgo}
										listadoEstado={listadoEstado}
										listadoTipoHallazgo={listadoTipoHallazgo}
									/>
								}
							</Tab>
						</Tabs>
					</Card>
				</div>
			</div>
			<ModalDetalleEventoConcesion
				show={show}
				onHide={handleClose}
				datosModal={datosModal}
			/>
			<ModalDetalleHallazgoBitacora
				show={showHallazgo}
				datosModal={datosModalHallazgo}
				onHide={handleCloseHallazgo}
			/>
		</div>
	)
}

export default BitacoraEventosConcesionPage;
